class BillUnit {
  public readonly id: string;
  public readonly partnerName: string;
  public readonly departmentName: string;
  public readonly tel: string;
  public readonly email: string;
  public readonly address: string;
  public readonly nameSuffix: string;
  public readonly personName: string;
  public readonly operationDate: Date;
  public readonly dueDate: Date;

  constructor({
    id,
    partnerName,
    departmentName,
    tel,
    email,
    address,
    nameSuffix,
    personName,
    operationDate,
    dueDate,
  }: {
    id: string;
    partnerName: string;
    departmentName: string;
    tel: string;
    email: string;
    address: string;
    nameSuffix: string;
    personName: string;
    operationDate: Date;
    dueDate: Date;
  }) {
    this.id = id;
    this.partnerName = partnerName;
    this.departmentName = departmentName;
    this.tel = tel;
    this.email = email;
    this.address = address;
    this.nameSuffix = nameSuffix;
    this.personName = personName;
    this.operationDate = operationDate;
    this.dueDate = dueDate;
  }

  public static fromJSON = (value: any) => {
    const {
      id,
      partner_name,
      department_name,
      tel,
      email,
      address,
      name_suffix,
      person_name,
      operation_date,
      due_date,
    } = Object.assign({}, value);

    if (typeof id !== 'number') throw new TypeError('.id must be a number');
    if (typeof partner_name !== 'string') throw new TypeError('.partner_name must be a string');
    if (typeof department_name !== 'string') throw new TypeError('.department_name must be a string');
    if (typeof tel !== 'string') throw new TypeError('.tel must be a string');
    if (typeof email !== 'string') throw new TypeError('.email must be a string');
    if (typeof address !== 'string') throw new TypeError('.address must be a string');
    if (typeof name_suffix !== 'string') throw new TypeError('.name_suffix must be a string');
    if (typeof person_name !== 'string') throw new TypeError('.person_name must be a string');
    if (typeof operation_date !== 'string' || new Date(operation_date).toString() === 'Invalid Date')
      throw new TypeError('.operation_date must be a string');
    if (typeof due_date !== 'string' || new Date(due_date).toString() === 'Invalid Date')
      throw new TypeError('.due_date must be a string');

    return new BillUnit({
      id: String(id),
      partnerName: String(partner_name),
      departmentName: String(department_name),
      tel: String(tel),
      email: String(email),
      address: String(address),
      nameSuffix: String(name_suffix),
      personName: String(person_name),
      operationDate: new Date(operation_date),
      dueDate: new Date(due_date),
    });
  };
}

export default BillUnit;
